// Every Today row carries art (29 Jul 2026): a card with no image of its
// own shows its topic's stand-in, so the list never mixes illustrated and
// bare rows. The purpose-made generic images are specified in
// docs/image-generation/generics.jsonl.
const ART: Record<string, string> = {
  sleep: "/images/practices/generic--sleep.webp",
  movement: "/images/practices/generic--movement.webp",
  food: "/images/practices/generic--food.webp",
  exposure: "/images/practices/generic--exposure.webp",
  behaviour: "/images/practices/generic--behaviour.webp",
  timing: "/images/practices/generic--timing.webp",
  longfast: "/images/practices/generic--longfast.webp",
  restrictive: "/images/practices/generic--restrictive.webp",
  supplements: "/images/practices/generic--supplements.webp",
  detox: "/images/practices/generic--detox.webp",
  vaccines: "/images/practices/generic--vaccines.webp",
  hormones: "/images/practices/generic--hormones.webp",
  mental: "/images/practices/generic--mental.webp",
  skin: "/images/practices/generic--skin.webp",
  sex: "/images/practices/generic--sex.webp",
  screening: "/images/practices/generic--screening.webp",
  mortality: "/images/practices/generic--mortality.webp",
};

const DEFAULT_ART = "/images/practices/generic--behaviour.webp";

export function artFor(card: { image: string | null; topicId: string | null }): string {
  return card.image ?? ART[card.topicId ?? ""] ?? DEFAULT_ART;
}

// A Crossfire question has no topic of its own, so when neither it nor the
// practices it draws carry an illustration there is nothing to derive a
// stand-in from. One neutral picture rather than a blank tile, so the list
// never mixes illustrated and bare rows (2 Aug 2026).
export const XF_FALLBACK = DEFAULT_ART;
